import {
  checkDateIsAvailable,
  endTimeValidator,
  numberToChinese,
  startTimeValidator,
} from '../helper';
import { Col, DatePicker, Form, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import sharedStyles from '../sharedStyles.module.scss';
import type { FreezeFormValue, MemberFreezeDetailResponse } from '../types';

interface HistoryDurationsProps {
  freezeDetail: MemberFreezeDetailResponse;
  handleDurationClick: (index: number) => void;
  freezeDuration: FreezeFormValue | undefined;
  index: number;
}

const { Item } = Form;
const { Text } = Typography;

const HistoryDurations = ({
  freezeDetail,
  handleDurationClick,
  freezeDuration,
  index,
}: HistoryDurationsProps) => {
  const { freezeCountLeft, freezeDurationLeft } = freezeDetail;

  return (
    <>
      {freezeDetail.freezeHistory.map((duration, index) => {
        const isEndTimeSameOrAfter = dayjs(
          duration.freezeEndTime
        ).isSameOrAfter(dayjs());

        const chineseNumber = numberToChinese(index);
        const dateFormat = 'YYYY/MM/DD';

        let durationElementProps = {};
        if (isEndTimeSameOrAfter) {
          durationElementProps = {
            className: sharedStyles.editableDuration,
            onClick: () => handleDurationClick(index),
          };
        }

        return (
          <Item
            key={duration.freezeStartTime}
            label={
              index !== 0 ? (
                <Text type="secondary">
                  {'第' + chineseNumber + '次凍結時間'}
                </Text>
              ) : (
                <Text type="secondary">首次凍結時間</Text>
              )
            }
          >
            <span {...durationElementProps}>
              {dayjs(duration.freezeStartTime).format(dateFormat) +
                ' - ' +
                dayjs(duration.freezeEndTime).format(dateFormat)}
            </span>
          </Item>
        );
      })}
      {freezeCountLeft !== 0 && freezeDurationLeft !== 0 && (
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Item
              label={<Text type="secondary">凍結開始日期</Text>}
              name="freezeStartTime"
              rules={[
                {
                  required: true,
                  validator: (_rules, value) =>
                    startTimeValidator({
                      freezeDetail,
                      freezeStartTime: value,
                      freezeEndTime: freezeDuration?.freezeEndTime,
                    }),
                },
              ]}
            >
              <DatePicker
                placeholder="請選擇凍結開始日期"
                className={sharedStyles.widthFull}
                format="YYYY/MM/DD"
                disabledDate={(date) =>
                  checkDateIsAvailable({
                    date,
                    freezeHistory: freezeDetail.freezeHistory,
                    historyIndex: index,
                  })
                }
              />
            </Item>
          </Col>
          <Col span={12}>
            <Item
              label={<Text type="secondary">凍結結束日期</Text>}
              name="freezeEndTime"
              rules={[
                {
                  required: true,
                  validator: (_rules, value) =>
                    endTimeValidator({
                      freezeStartTime: freezeDuration?.freezeStartTime,
                      freezeEndTime: value,
                      freezeDetail,
                    }),
                },
              ]}
            >
              <DatePicker
                placeholder="請選擇凍結結束日期"
                className={sharedStyles.widthFull}
                format="YYYY/MM/DD"
                disabledDate={(date) =>
                  checkDateIsAvailable({
                    date,
                    freezeHistory: freezeDetail.freezeHistory,
                    historyIndex: index,
                  })
                }
              />
            </Item>
          </Col>
        </Row>
      )}
    </>
  );
};

export default HistoryDurations;
